module.exports = __webpack_public_path__ + "static/media/language_game_batb.44cd1bf6.jpg";